export const tablePage = {
  CASES_TABLE: "casesTable",
  CONTACT_CASES_TABLE: "contactCasesTable",
};

export const VALUES_PER_PAGE = 10;
